import { Component, OnInit, Input, EventEmitter, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subscription } from 'rxjs';

import { LocationLookupService } from '../../services/location-lookup.service';
import { Location } from '../../models/location';

@Component({
    selector: 'location-search',
    templateUrl: './location-search.component.html',
    styleUrls: ['./location-search.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => LocationSearchComponent),
        }
    ]
})
export class LocationSearchComponent implements OnInit, ControlValueAccessor {
    @Input() value: Location;

    @Output() input: EventEmitter<Location> = new EventEmitter<Location>();
    @Output() selected: EventEmitter<Location> = new EventEmitter<Location>();

    @Input() inputId: string;
    @Input() disabled: boolean;
    @Input() readonly: boolean;
    @Input() tabindex: number;
    @Input() name: string;

    private searchSubscription: Subscription = null;

    suggestions: Location[] = [];

    onChange: ((val: Location) => void)[] = [];
    onTouched: (() => void)[] = [];

    selecting: boolean = true;

    debounceHandle: any = null;

    constructor(private locationService: LocationLookupService) {
    }

    ngOnInit(): void {
    }

    UpdateSuggestions(query: string): void {
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }

        this.searchSubscription = this.locationService.findLocations(query).subscribe(results => {
            this.searchSubscription = null;

            this.suggestions = results;
        });
    }

    Focused(): void {
        this.onTouched.forEach(f => f());
        this.selecting = true;
    }

    Blurred(): void {
        if (this.selecting) {
            this.selecting = false;
            if (this.searchSubscription) {
                this.searchSubscription.add(() => {
                    this.SuggestionPicked(this.suggestions[0]);
                });
            }
            else if (!this.value) {
                this.SuggestionPicked(null);
            }
        }
    }

    Cleared(): void {
    }

    Selected(pick: Location): void {
        this.selecting = false;
        this.SuggestionPicked(pick);
    }

    // the debounce algorithm here is a workaround for Blur firing on selected resulting in a transient "null" pick.
    // there's probably a better solution.
    SuggestionPicked(pick: Location): void {
        if (this.debounceHandle) {
            clearTimeout(this.debounceHandle);
            this.debounceHandle = null;
        }
        this.debounceHandle = setTimeout(() => {
            this.debounceHandle = null;
            this.value = pick;
            this.onChange.forEach(f => f(pick));
            this.input.emit(pick);
            this.selected.emit(pick);
        }, 100);
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnTouched(fn: any): void {
        this.onTouched.push(fn);
    }

    registerOnChange(fn: any): void {
        this.onChange.push(fn);
    }

    writeValue(obj: any): void {
        if (obj) {
            const loc = new Location(-1, obj.city, obj.state, obj.postalCode);

            const match = this.suggestions.find(s => s.equals(loc));

            if (!match)
                this.suggestions = [loc, ...this.suggestions];

            this.value = match || loc;
        }
        else {
            this.value = null;
        }

    }
}
